module.exports = __webpack_public_path__ + "static/media/bgTwo.baa9df0a.jpg";